import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

Swiper.use([Pagination, Navigation]);

const swiperNavNextSelector = '.swiper-button-next';
const swiperNavPrevSelector = '.swiper-button-prev';
const swiperPaginationSelector = '.swiper-pagination';

const swiperConfig = {
    slidesPerView: 'auto',
    spaceBetween: 24,
    navigation: {
        nextEl: swiperNavNextSelector,
        prevEl: swiperNavPrevSelector,
    },
    pagination: {
        el: swiperPaginationSelector,
        type: 'fraction',
        renderFraction: (currentClass, totalClass) => {
            return `<span class="${currentClass}"></span><span></span>/<span class="${totalClass}"></span>`;
        }
    },
};

function initSwipers() {
    const sliders = document.querySelectorAll('.swiper');

    sliders.forEach(slider => {
        const next = slider.parentNode.querySelector(swiperNavNextSelector);
        const prev = slider.parentNode.querySelector(swiperNavPrevSelector);
        const pagination = slider.parentNode.querySelector(swiperPaginationSelector);

        const swiperInstance = new Swiper(slider, {
            ...swiperConfig,
            navigation: { nextEl: next, prevEl: prev },
            pagination: { ...swiperConfig.pagination, el: pagination },
        });

        swiperInstance.update();
    });
}

window.addEventListener('DOMContentLoaded', () => {
    requestAnimationFrame(initSwipers);
});
